const routes = [
  {
    path: 'alert-msg',
    name: 'alert-msg',
    component: () => import(/* webpackChunkName: "alert-msg" */ '@/modules/alert-msg/index.vue')
  },
];

export default routes;